////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> /login                            //
//                                                //
//  PÁGINA PARA REALIZAR LOGIN DE USUÁRIO JÁ      //
//  EXISTENTE OU PARA CRIAR UM NOVO USUÁRIO       //
//                                                //
//  NÃO RECEBE NADA COMO PARÂMETRO NA URL.        //
//                                                //
////////////////////////////////////////////////////  



import React from "react"

import Franqueado from  '../components/franqueado';
import FormLogin from "../components/form_login";
import FormCriarUsuario from "../components/form_criar_usuario";


function login() {

  function collapse_div(toggle, fechar){  // FUNÇÃO QUE COLLAPSA AS DIVS PARA PERMITIR QUE APENAS UM CARD APAREÇA POR VEZ
    // FUNÇÃO CHAMADA AO CLICAR NOS BOTÕES 'btn_fazer_login' OU 'btn_criar_usuario' desta página

    if(document.getElementById(toggle).classList.contains('d-none')){
      document.getElementById('msg').innerText=''
      document.getElementById('msg_login').innerText=''
      document.getElementById(toggle).classList.remove('d-none')
    }
    else{
      document.getElementById(toggle).classList.add('d-none')
    }

    document.getElementById(fechar).classList.add('d-none')
  }

  // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
    // 'Franqueado' -> CHECKBOX PARA OPÇÃO DE REALIZAR LOGIN COMO FRANQUEADO
    // 'FormLogin' -> FORM PARA PREENCHIMENTO DE LOGIN E SENHA CASO USUÁRIO JÁ POSSUA CONTA NO CATÁLOGO
    // 'FormCriarUsuario' -> FORM PARA PREENCHIMENTO DE DADOS PESSOAIS PARA CRIAÇÃO DE CONTA NO CATÁLOGO

  return(
    <div>
      <Franqueado />
      
      <div class="card-login">  
        <button id='btn_fazer_login' class="w-100 btn-collapse fonte-x-large" onClick={() => collapse_div('form_login', 'form_criar_usuario')}>Fazer Login</button>
        <div id="form_login">
          <div class="w-100 card-checkout mt-1 mb-5">
            <FormLogin />
          </div>
        </div>

        <button id='btn_criar_usuario' class="w-100 btn-collapse fonte-x-large mt-3" onClick={() => collapse_div('form_criar_usuario', 'form_login')}>Criar Usuário</button>
        <div id="form_criar_usuario" class="d-none">
          <div class="w-100 card-checkout mt-1 mb-5">
            <FormCriarUsuario />
          </div>
        </div>

      </div>
    </div>
)
}

export default login;
